import http from "../http";
import Service from "../../Service";

/**
 * Ordem de compras do cliente (kyojin GET /clients/reports/orders).
 * Substitui o listarpedidos?total=true da api legada nessa aba.
 */
export default class OrderReportService extends Service {
    list(params) {
        return http.get("clients/reports/orders", {
            headers: this.getHeaders(),
            params,
        });
    }

    export(params) {
        return http.get("clients/reports/orders", {
            headers: this.getHeaders(),
            params: { ...params, export: "xlsx" },
            responseType: "blob",
        });
    }
}
